import { Box } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const ContentLabelContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
